<template>
  <div :class="b()">
    <div :class="b('list')">
      <e-loading-indicator
        v-if="productStore.runningRequests.apiFetchProductBundles"
        :class="b('loader')"
        size="medium"
        fullwidth
      />

      <c-product-bundle
        v-for="bundleConfig in bundleList"
        :key="`bundle-${isApiFetchModeActive}-${bundleConfig.bundle.name}`"
        :bundle-config="bundleConfig"
        :highlight-id="groupId"
      />
    </div>
    <c-pagination
      v-if="listPagination.moreThanOnePage()"
      :pagination="listPagination"
      @change="onPaginationChanged"
    />
  </div>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import useProductStore from '@/stores/product';
  import cPagination from '@/components/c-pagination.vue';
  import cProductBundle from '@/components/c-product-bundle.vue';
  import eLoadingIndicator from '@/elements/e-loading-indicator.vue';
  import { Pagination } from '@/helpers/pagination';
  import { ProductBundle } from '@/types/product';

  type Setup = {
    productStore: ReturnType<typeof useProductStore>;
  };

  type Data = {
    isApiFetchModeActive: boolean;
    apiBundleList: ProductBundle[];
    listPagination: Pagination;
  };

  /**
   * Renders a list of bundles which fetches new bundles from the API.
   */
  export default defineComponent({
    name: 'c-product-bundle-list',
    components: {
      eLoadingIndicator,
      cPagination,
      cProductBundle,
    },

    props: {
      /**
       * The product id on which basis bundles should be fetched.
       */
      productId: {
        type: Number,
        required: true,
      },

      /**
       * The group id used to detect the highlighted product.
       */
      groupId: {
        type: Number,
        required: true,
      },

      /**
       * The initial list to display.
       */
      initialList: {
        type: Array as PropType<ProductBundle[]>,
        required: true,
      },

      /**
       * The pagination.
       */
      pagination: {
        type: Object as PropType<Pagination>,
        required: true,
      },
    },
    // emits: [],

    setup(): Setup {
      return {
        productStore: useProductStore(),
      };
    },
    data(): Data {
      return {
        isApiFetchModeActive: false,
        apiBundleList: [],
        listPagination: new Pagination(),
      };
    },

    computed: {
      bundleList(): ProductBundle[] {
        return this.isApiFetchModeActive ? this.apiBundleList : this.initialList;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    mounted() {
      const { pagination } = this;

      this.listPagination.update(pagination);
    },
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      onPaginationChanged(page: number) {
        this.listPagination.update({ current: page });

        this.productStore.apiFetchProductBundles(this.productId, this.listPagination).then((response) => {
          this.apiBundleList = response.data;
          this.isApiFetchModeActive = true;
          this.listPagination.update(response.pagination);
        });
      },
    },
    // render() {},
  });
</script>

<style lang="scss">
  .c-product-bundle-list {
    display: flex;
    flex-direction: column;
    gap: 3rem;

    &__list {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 3rem;
    }
  }
</style>
